import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateAssistenciaArquivoDiversoUseCase } from "../../../presentation/useCases/create/create_assistencia_arquivo_diverso_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateAssistenciaArquivoDiversoUseCase
 */

export class CreateAssistenciaArquivoDiversoUseCase implements ICreateAssistenciaArquivoDiversoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createAssistenciaArquivoDiverso(
    idAssistenciaTecnica: number,
    descricao: string,
    arquivo: File | null
  ): Promise<void> {
    if (!arquivo) throw new UserFriendlyError("Você deve selecionar um arquivo!");

    FileUtils.validateFileSize(arquivo);

    await this.repository.createAssistenciaArquivoDiverso(
      idAssistenciaTecnica,
      descricao,
      arquivo,
    );
  }
}
